let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("77vT3")).then(() => parcelRequire('jcyQJ'));